import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const AddComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame">
        <g id="Group">
          <g id="Vector">
            <path d="M61.3444 103.692V116.121V103.692ZM61.3444 50.4484V66.1691V50.4484ZM91.2443 117.084H31.4445L24 50H98.6888L91.2443 117.084Z" />
            <path
              d="M61.3444 103.692V116.121M61.3444 50.4484V66.1691M91.2443 117.084H31.4445L24 50H98.6887L91.2443 117.084Z"
              stroke="#686869"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_2"
            d="M78.3234 97.8746L76.1662 117.312H46.507L44.3158 97.5669M41.7463 74.4127L39.0625 50.228H83.6106L80.8005 75.5522"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M85.3662 14.2892C88.77 14.2892 91.5294 11.5382 91.5294 8.14461C91.5294 4.75104 88.77 2 85.3662 2C81.9624 2 79.2031 4.75104 79.2031 8.14461C79.2031 11.5382 81.9624 14.2892 85.3662 14.2892Z"
            fill="white"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M18 37.5164H104.674V50.228H18V37.5164ZM103.239 37.5164C103.475 36.7413 103.595 35.9353 103.594 35.1248C103.594 30.6 99.9152 26.9318 95.3766 26.9318C95.0849 26.9318 94.7934 26.9471 94.5033 26.9777C93.2018 24.237 90.4024 22.3411 87.1587 22.3411C85.1718 22.3378 83.2529 23.0645 81.7666 24.3832C80.5062 22.0038 77.9995 20.3822 75.113 20.3822C71.2767 20.3822 68.1117 23.2463 67.6509 26.9463C67.4484 26.9583 67.2478 26.9777 67.0498 27.004C66.1125 22.4906 62.1026 19.0981 57.2979 19.0981C54.1748 19.0981 51.3877 20.5315 49.5616 22.7742C48.4774 18.461 44.5636 15.2667 39.9012 15.2667C34.4011 15.2667 29.9423 19.7121 29.9423 25.1958C29.9423 25.9741 30.0323 26.7316 30.2023 27.4584C29.2736 27.1089 28.2893 26.9304 27.297 26.9316C22.7583 26.9316 19.0791 30.5998 19.0791 35.1246C19.0791 35.9566 19.2035 36.7596 19.4348 37.5162H103.239V37.5164Z"
            fill="white"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_5"
            d="M61.3336 107.742C74.613 107.742 85.3781 97.0096 85.3781 83.7701C85.3781 70.5305 74.613 59.7977 61.3336 59.7977C48.0542 59.7977 37.2891 70.5305 37.2891 83.7701C37.2891 97.0096 48.0542 107.742 61.3336 107.742Z"
            fill="#CCE7FE"
          />
          <path
            id="Vector_6"
            d="M61.3368 94.7031C67.393 94.7031 72.3025 89.8082 72.3025 83.7702C72.3025 77.7321 67.393 72.8373 61.3368 72.8373C55.2806 72.8373 50.3711 77.7321 50.3711 83.7702C50.3711 89.8082 55.2806 94.7031 61.3368 94.7031Z"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

AddComment.displayName = 'AddComment';
